import axios from 'axios';

const apiHelper = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiHelper;
